import React, { useState, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'

import { useAuth0 } from '@auth0/auth0-react'

import Layout from '../components/Layout/Layout'
import Routes from '../Routes/Routes'
import HeaderProvider from '../providers/HeaderProvider'
import LocationProvider from '../providers/LocationProvider'
import AppErrorBoundary from '../components/UI/ErrorBoundary/AppErrorBoundary'
import errorTrackingService from '../services/errorTrackingService'

import './pregnancy.css'
import './default.css'
import { PrivacyModal } from '../components/UI/PrivacyModal/PrivacyModal'
import PrivacyModalProvider from '../providers/PrivacyModalProvider'
import MswForceFlagSync from '../mocks/MswForceFlagSync'

function App () {
  const { isAuthenticated, logout, isLoading } = useAuth0()
  const [mode, setMode] = useState('default')

  if (window.location.pathname === '/') {
    window.location.pathname = '/login'
  }

  const theme = createTheme({
    typography: {
      fontFamily: 'Montserrat',
      fontStyle: 'normal'
    },
    palette: {
      primary: {
        main: mode === 'pregnancy' ? '#573377' : '#7b1646'
      },
      secondary: {
        main: mode === 'pregnancy' ? '#EAE6FF' : '#FCF0E6'
      }
    }
  })

  // Global error listeners
  useEffect(() => {
    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection capturada por App:', event.reason)
      const error = event.reason instanceof Error ? event.reason : new Error(event.reason)
      errorTrackingService.trackJavaScriptError(error, {
        context: 'unhandled_promise_rejection',
        isUnhandledRejection: true,
        capturedBy: 'globalErrorListener'
      })
    }

    const handleGlobalError = (event) => {
      console.error('Error global capturado por App:', event.error)
      if (event.error) {
        errorTrackingService.trackJavaScriptError(event.error, {
          context: 'global_error',
          isGlobalError: true,
          capturedBy: 'globalErrorListener'
        })
      }
    }

    window.addEventListener('unhandledrejection', handleUnhandledRejection)
    window.addEventListener('error', handleGlobalError)

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection)
      window.removeEventListener('error', handleGlobalError)
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <MswForceFlagSync />
        <AppErrorBoundary>
          <HeaderProvider setMode={setMode}>
            <PrivacyModalProvider>
              <LocationProvider>
                <Layout>
                  <Routes
                    isAuthenticated={isAuthenticated}
                    isLoading={isLoading}
                    logout={logout}
                  />
                </Layout>
              </LocationProvider>
              <PrivacyModal />
            </PrivacyModalProvider>
          </HeaderProvider>
        </AppErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
